import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { InfoHacienda, SucursalSimple } from '../interfaces';

@Injectable()
export class SucursalesService {
  private filtroSociedad_id = -1;
  private reasignandoSociedades = false;
  private listaSucursales: SucursalSimple[] = null;
  constructor(private readonly generalApi: GeneralApiService, private readonly storageService: StorageService) {}
  resetearReasignacion() {
    this.filtroSociedad_id = -1;
    this.reasignandoSociedades = false;
  }
  activarReasignacion(sociedad_id: number) {
    this.filtroSociedad_id = sociedad_id;
    this.reasignandoSociedades = true;
  }
  seleccionarFiltroSociedadId(sociedad_id: number) {
    this.filtroSociedad_id = sociedad_id;
  }
  getReasignandoSociedades() {
    return this.reasignandoSociedades;
  }
  getFiltroSociedad() {
    return this.filtroSociedad_id;
  }
  getOldListaSucursales(loading?: StatusApi) {
    if (!this.listaSucursales) return this.getListaSucursales(loading);
    loading.setDone();
    return this.listaSucursales;
  }
  getListaSucursales(loading?: StatusApi) {
    return this.generalApi
      .callApi<SucursalSimple[]>('get', `/empresa/${this.storageService.getEmpresaID()}/sucursales`, { loading })
      .then(response => {
        const respuesta = response as SucursalSimple[] | { sucursales?: SucursalSimple[]; data?: SucursalSimple[] };
        const sucursales = Array.isArray(respuesta)
          ? respuesta
          : respuesta?.sucursales || respuesta?.data || [];
        this.listaSucursales = sucursales;
        return sucursales;
      });
  }
  guardarReasignacion(newSucursales: SucursalSimple[], loading?: StatusApi) {
    return this.generalApi.callApi<any>('post', '', {
      postData: newSucursales,
      loading,
      mockResult: true,
      toastSuccess: '¡Las sucursales se han cambiado de sociedad correctamente!'
    });
  }
  activarSucursal(sucursal_id: number, loading?: StatusApi) {
    return this.generalApi.callApi<any>('post', `/empresa/${this.storageService.getEmpresaID()}/sucursal/${sucursal_id}/activar`, { loading });
  }
  async desactivarSucursal(sucursal_id: number, loading?: StatusApi) {
    try {
      await this.generalApi.callApi<any>('post', `/empresa/${this.storageService.getEmpresaID()}/sucursal/${sucursal_id}/desactivar`, { loading });
      return { esOk: true };
    } catch (error) {
      const data = error && typeof error === 'object' && 'data' in error ? error.data : undefined;
      return { esOk: false, error: data };
    }
  }
  getInfoHacienda(loading?: StatusApi) {
    return this.generalApi.callApi<InfoHacienda>('get', `/eus/ticket_bai/obtener-info-mensaje-hacienda/${this.storageService.getEmpresaID()}`, { loading, keyResult: null });
  }
}
